import { View } from './view'

export const MobileMenu = View
